module.exports = __webpack_public_path__ + "img/btn_code_copy_gray.a795c3b.svg";